/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshTokenRequest } from '../../models/refresh-token-request';
import { RefreshTokenResult } from '../../models/refresh-token-result';

export interface PostRefresh$Params {
  body?: RefreshTokenRequest;
}

export function postRefresh(
  http: HttpClient,
  rootUrl: string,
  params?: PostRefresh$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RefreshTokenResult>> {
  const rb = new RequestBuilder(rootUrl, postRefresh.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RefreshTokenResult>;
    }),
  );
}

postRefresh.PATH = '/Authentication/refresh';
